'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = function (element, className) {
  var classes = element.className.split(' ');
  var i = classes.indexOf(className);

  if (i !== -1) {
    classes.splice(i, 1);
  }

  return classes.join(' ');
};